// extracted by mini-css-extract-plugin
module.exports = {"limited_stock":"stockLabel_limited_stock__dW6SG"};